import { render, staticRenderFns } from "./MarksWrapper.vue?vue&type=template&id=032e5826"
import script from "./MarksWrapper.vue?vue&type=script&lang=js"
export * from "./MarksWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports